import Quill from 'quill';

const Embed = Quill.import('blots/embed');

class AnchorBlot extends Embed {
    static create(data) {
        const node = super.create();
        node.setAttribute('id', 'anchor-'+data);
        node.setAttribute('contenteditable', false);
        return node;
    }

    static value(domNode) {
        if (domNode.getAttribute('id').substring(0, 7) === 'anchor-') {
            return domNode.getAttribute('id').slice(7);
        }
        return domNode.getAttribute('id');
    }
}

AnchorBlot.blotName = 'anchor';
AnchorBlot.className = 'ql-anchor';
AnchorBlot.tagName = 'a';

Quill.register(AnchorBlot);

export default AnchorBlot;